import { render, staticRenderFns } from "./operate_record.vue?vue&type=template&id=6f336260&scoped=true&"
import script from "./operate_record.vue?vue&type=script&lang=tsx&"
export * from "./operate_record.vue?vue&type=script&lang=tsx&"
import style0 from "./operate_record.vue?vue&type=style&index=0&id=6f336260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f336260",
  null
  
)

export default component.exports